<template>
  <div class="">
    <Page :title="pageTitle">
      <div class="">
        <div>
          <div class="Polaris-Tabs__Outer">
            <div
              class="Polaris-Box"
              style="--pc-box-padding-block-start-md:var(--p-space-200);--pc-box-padding-block-end-md:var(--p-space-200);--pc-box-padding-inline-start-md:var(--p-space-200);--pc-box-padding-inline-end-md:var(--p-space-200)"
            >
              <div class="Polaris-Tabs Polaris-Tabs__TabsMeasurer">
                <li
                  v-for="(tab, index) of tabs"
                  :key="index"
                  class="Polaris-Tabs__TabContainer"
                  role="presentation"
                >
                  <router-link
                    :id="`${tab.routeName}-measurer`"
                    class="Polaris-Tabs__Tab"
                    :class="{
                      'Polaris-Tabs__Tab--active': $route.name === tab.routeName
                    }"
                    role="tab"
                    :to="{ name: tab.routeName }"
                    type="button"
                    tabindex="-1"
                    :aria-selected="$route.name === tab.routeName"
                  >
                    <div
                      class="Polaris-InlineStack"
                      style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                    >
                      <span
                        class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                        >{{ tab.label }}</span
                      >
                    </div>
                  </router-link>
                </li>
              </div>
              <div class="Polaris-Tabs__Wrapper">
                <div class="Polaris-Tabs__ButtonWrapper">
                  <ul
                    class="Polaris-Tabs"
                    data-tabs-focus-catchment="true"
                    role="tablist"
                  >
                    <li
                      v-for="(tab, index) of tabs"
                      :key="index"
                      class="Polaris-Tabs__TabContainer"
                      role="presentation"
                    >
                      <router-link
                        :id="tab.routeName"
                        class="Polaris-Tabs__Tab"
                        :class="{
                          'Polaris-Tabs__Tab--active':
                            $route.name === tab.routeName
                        }"
                        :aria-label="tab.label"
                        role="tab"
                        event
                        :to="{ name: tab.routeName }"
                        type="button"
                        :aria-controls="`${tab.routeName}-content`"
                        :tabindex="$route.name === tab.routeName ? 0 : -1"
                        :aria-selected="$route.name === tab.routeName"
                        @click.native.prevent="handleNavClick(tab)"
                      >
                        <div
                          class="Polaris-InlineStack"
                          style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >{{ tab.label }}</span
                          >
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              class="Polaris-Tabs__Panel"
              :id="`${$route.name}-content`"
              role="tabpanel"
              :aria-labelledby="$route.name"
              tabindex="-1"
            >
              <div class="Polaris-LegacyCard__Section">
                <transition>
                  <keep-alive>
                    <router-view></router-view>
                  </keep-alive>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";

export default {
  components: {
    Page
  },
  data() {
    return {
      pageTitle: "Settings",
      tabs: [
        {
          label: "Plans",
          routeName: "Plan"
        },
        {
          label: "Manual Message Sending Preference",
          routeName: "Preference"
        },
        {
          label: "Email & Push Notifications",
          routeName: "Notifications"
        },
        {
          label: "Language",
          routeName: "Language"
        }
      ]
    };
  },
  methods: {
    handleNavClick(tab) {
      console.log(tab);
      const saveBar = document.getElementById("my-save-bar");
      if (saveBar && saveBar.showing) {
        console.log("savebar showing");
        // saveBar.leaveConfirmation();
        // eslint-disable-next-line
        shopify.saveBar.leaveConfirmation();
        // history.pushState(null, "", `#/${tab.routeName}`);
      } else {
        this.$router.push({ name: tab.routeName });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
